import { PermisoesHelper } from "../../helpers";
import {
  CentroCustoService,
  ContasReceberService,
  PlanosFinanceirosService,
} from "../../services";
import { ImportarTitulos } from "./components";
import { TituloReceber } from "./entities";
import {
  buscarCadastro,
  buscarMeiosPagamento,
  buscarPessoas,
  colunasGrid,
  descricaoCadastro,
  lerPlanilha,
} from "./importar-titulos";

const contasReceberService = new ContasReceberService();
const planosFinanceirosService = new PlanosFinanceirosService();
const centroCustoService = new CentroCustoService();

const colunas = colunasGrid("Pagador", [
  {
    field: "planoFinanceiroId",
    headerName: "Plano Financeiro",
    width: 250,
    valueGetter: (params) =>
      descricaoCadastro(params.value, params.row.planoFinanceiroDescricao),
  },
  {
    field: "centroCustoId",
    headerName: "Centro de Custo",
    width: 250,
    valueGetter: (params) =>
      descricaoCadastro(params.value, params.row.centroCustoDescricao),
  },
]);

const ImportarContasReceberView = () => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("contas-receber-cadastrar");

  async function montarTitulos(arquivo) {
    const linhas = await lerPlanilha(arquivo, "Pagador");
    const [pessoas, meiosPagamento, planosFinanceiros, centrosCusto] =
      await Promise.all([
        buscarPessoas(linhas),
        buscarMeiosPagamento(),
        buscarCadastro(
          planosFinanceirosService.getAll({
            nonPaginated: true,
            natureza: "credito",
          }),
          "Erro ao buscar os planos financeiros",
        ),
        buscarCadastro(
          centroCustoService.getAll({ nonPaginated: true }),
          "Erro ao buscar os centros de custo",
        ),
      ]);
    const cadastros = {
      pessoas,
      meiosPagamento,
      planosFinanceiros,
      centrosCusto,
    };
    return linhas.map((linha) => new TituloReceber(linha, cadastros));
  }

  return (
    <ImportarTitulos
      tituloTela="Importação de Contas a Receber"
      colunas={colunas}
      montarTitulos={montarTitulos}
      service={contasReceberService}
      rotaListagem="/financeiro/contas-receber"
    />
  );
};

export default ImportarContasReceberView;
